import React from "react";
import "./POSAnimation.css";

const POSAnimation = () => {
  return (
    <div className="pos-wrapper">
      <div className="card-wrapper">
        <div className="card">
          <div className="chip"></div>
          <div className="number">•••• 1234</div>
          <div className="magnetic-stripe"></div>
        </div>
      </div>
      <div className="pos-body">
        <div className="pos-device">
          <div className="pos-brand">PAYSAFEGATE</div>
          <div className="pos-screen">
            <div className="spinner"></div>
          </div>
          <div className="pos-buttons">
            <div className="pos-btn"></div>
            <div className="pos-btn"></div>
            <div className="pos-btn"></div>
            <div className="pos-btn"></div>
            <div className="pos-btn"></div>
            <div className="pos-btn"></div>
            <div className="pos-btn"></div>
            <div className="pos-btn"></div>
            <div className="pos-btn"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default POSAnimation;
